import React from "react";
import rightArrow from "../../../images/faq-arrow-right.svg";


const OtherAmc = ({ allAmcs }) => {
  return (
    <>
      <p className="heading-4-bold otherAmcHeading">Other AMC's</p>
      <div className="shadow-normal rounded bg-white otherAmcContainer">
        {allAmcs &&
          allAmcs.map((amc, key) => (
            <a
              target="_blank"
              href={`https://www.piggy.co.in/mutual-funds/amc/${amc.display_name_id.replace(
                /_/g,
                "-"
              )}/`}
            >
              <div className="flex space-between para-3-bold bold otherAmcPoint">
                {amc.name}
                <img src={rightArrow} alt="" />
              </div>
            </a>
          ))}
      </div>
      <style jsx>{`.otherAmcHeading{
          margin: 30px 0 16px;
        }
      .otherAmcContainer{
        box-sizing: border-box;
      }
      .otherAmcPoint{
        padding:16px;        
        border-bottom: 1px solid #e6e6e6;
      }.otherAmcPoint:hover {
        cursor: pointer;
        color: #4dc3b6;
        background-color: rgb(77, 195, 182, 0.05);
      }
      `}</style>
    </>
  );
};
export default OtherAmc;
